import React, { createContext, useContext, useState } from 'react';

const ConsoleContext = createContext();

export const useConsole = () => useContext(ConsoleContext);

export const ConsoleProvider = ({ children }) => {
  const [consoleMessages, setConsoleMessages] = useState([]);
  const [isConsoleOpen, setIsConsoleOpen] = useState(false);

  const addConsoleMessage = (message) => {
    setConsoleMessages(prev => [...prev, { message, timestamp: new Date().toISOString() }]);
  };

  const clearConsoleMessages = () => {
    setConsoleMessages([]);
  };

  const openConsole = () => setIsConsoleOpen(true);
  const closeConsole = () => setIsConsoleOpen(false);

  return (
    <ConsoleContext.Provider value={{
      consoleMessages,
      addConsoleMessage,
      clearConsoleMessages,
      isConsoleOpen,
      openConsole,
      closeConsole
    }}>
      {children}
    </ConsoleContext.Provider>
  );
};